export default "__VITE_ASSET__BjBjc9Re__"